import { ChevronsUpDown } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ChevronsUpDownIcon = createLucideIcon(ChevronsUpDown);
